<template>
  <div class="w-100">
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="primary"
      class="mb-2 custom-tabs"
      grow
    >
      <v-tab class="font-weight-bold">
        <v-icon left>mdi-clipboard-list-outline</v-icon>
        Gestión de LMR
      </v-tab>
      <v-tab class="font-weight-bold">
        <v-icon left>mdi-table-pivot</v-icon>
        Matriz de LMR por Mercado
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!-- Pestaña 1: CRUD de Gestión -->
      <v-tab-item>
        <v-card flat>
          <s-crud
            ref="crudMRLs"
            @returnObject="refresh($event)"
            no-border
            title="Límites Máximos de Residuos (LMR)"
            :config="config"
            @save="save($event)"
            @clearForm="clearForm()"
            @addEvent="clearForm()"
            @activePrd="clearForm()"
            @rowSelected="rowSelected($event)"
            add
            edit
            remove
            restore
            :filter="filter"
            height="450"
            sortable
          >
            <!-- Filtros Superiores -->
            <template slot="filter">
              <v-row dense class="px-2 py-1 align-center">
                <v-col cols="12" md="3" lg="3">
                  <s-select-campaign-area
                    label="Campaña"
                    v-model="filter.CmaID"
                    typeArea="1"
                    clearable
                    noDefault
                  />
                </v-col>
                <v-col cols="12" md="3" lg="2">
                  <s-select-definition
                    label="Tipo de Producto"
                    :def="1740"
                    v-model="filter.TypeSubstances"
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <s-select-substances
                    label="Sustancia"
                    :type-substances="filter.TypeSubstances"
                    v-model="filter.AsuID"
                    clearable
                    noDefault
                  />
                </v-col>
                <v-col cols="12" md="3" lg="2">
                  <s-select-definition
                    label="Mercado / Destino"
                    :def="1736"
                    v-model="filter.TypeMarket"
                    clearable
                  />
                </v-col>
              </v-row>
            </template>

            <!-- Formulario Modal de Creación / Edición -->
            <template scope="props">
              <v-container v-if="props.item != null">
                <v-row dense>
                  <v-col cols="12" sm="6" md="4" lg="3" class="s-col-form">
                    <s-select-campaign-area
                      label="Campaña *"
                      v-model="props.item.CmaID"
                      typeArea="1"
                      :rules="[(v) => !!v || 'La campaña es obligatoria']"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="3" class="s-col-form">
                    <s-select-definition
                      label="Tipo de Producto"
                      :def="1740"
                      :add="$fun.isAdmin()"
                      v-model="props.item.TypeSubstances"
                      clearable
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="3" class="s-col-form">
                    <s-select-substances
                      label="Sustancia *"
                      :type-substances="props.item.TypeSubstances"
                      v-model="props.item.AsuID"
                      clearable
                      noDefault
                      :rules="[(v) => !!v || 'La sustancia es obligatoria']"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="3" class="s-col-form">
                    <s-select-definition
                      label="Tipo Cultivo"
                      :def="1173"
                      v-model="props.item.TypeCultive"
                      clearable
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="3" class="s-col-form">
                    <s-select-definition
                      label="Mercado / Destino *"
                      :def="1736"
                      v-model="props.item.TypeMarket"
                      :rules="[(v) => !!v || 'El mercado es obligatorio']"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="3" class="s-col-form">
                    <s-text
                      ref="MRLValue"
                      label="Valor LMR *"
                      v-model="props.item.MRLValue"
                      type="number"
                      step="0.000001"
                      :rules="[(v) => v !== null && v !== undefined && v !== '' || 'El valor LMR es obligatorio']"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="3" class="s-col-form">
                    <s-select-definition
                      label="Unidad de Medida"
                      :def="1106"
                      v-model="props.item.TypeUnit"
                      clearable
                    />
                  </v-col>
                </v-row>
              </v-container>
            </template>

            <!-- Slot personalizado para columna Estado -->
            <template v-slot:SecStatus="{ row }">
              <v-chip
                x-small
                :color="row.SecStatus == 1 ? 'success' : 'error'"
                dark
                style="margin: 0px"
              >
                {{ row.SecStatus == 1 ? "Activo" : "Inactivo" }}
              </v-chip>
            </template>
          </s-crud>
        </v-card>
      </v-tab-item>

      <!-- Pestaña 2: Matriz LMR por Mercado -->
      <v-tab-item>
        <v-card flat>
          <m-r-ls-matrix ref="matrixLMR" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import _sMRLsService from "@/services/Technicalassistance/MRLsService.js";
import SSelectSubstances from "@/components/TecnicalAssistence/Substances/SSelectSubstances.vue";
import MRLsMatrix from "./MRLsMatrix.vue";

export default {
  name: "TasMRLs",
  components: {
    SSelectSubstances,
    MRLsMatrix,
  },
  data: () => ({
    tab: 0,
    selected: [],
    filter: {
      CmaID: null,
      TypeSubstances: null,
      AsuID: null,
      TypeMarket: null,
    },
    config: {
      title: "Límites Máximos de Residuos",
      service: _sMRLsService,
      model: {
        MrlID: "ID",
        CmaID: "int",
        TypeCultive: "int",
        AsuID: "int",
        TypeMarket: "int",
        MRLValue: "decimal",
        TypeUnit: "int",
        SecStatus: "status",
      },
      headers: [
        {
          text: "ID",
          value: "MrlID",
          width: "5%",
          align: "end",
          sortable: true,
        },
        {
          text: "Campaña",
          value: "CmaName",
          width: "15%",
          sortable: true,
        },
        {
          text: "Tipo de Producto",
          value: "TypeProductName",
          width: "10%",
          sortable: true,
        },
        {
          text: "Sustancia",
          value: "SubstancesName",
          width: "30%",
          sortable: true,
        },
        {
          text: "Cultivo",
          value: "TypeCultiveName",
          width: "8%",
          sortable: true,
        },
        {
          text: "Mercado",
          value: "TypeMarketName",
          width: "15%",
          sortable: true,
        },
        {
          text: "Valor LMR",
          value: "MRLValue",
          width: "15%",
          align: "end",
          sortable: true,
        },
        {
          text: "Unidad",
          value: "TypeUnitName",
          width: "12%",
          sortable: true,
        },
        {
          text: "Estado",
          value: "SecStatus",
          width: "10%",
          align: "center",
          sortable: true,
        },
      ],
    },
  }),
  watch: {
    tab(val) {
      if (val === 1) {
        this.$nextTick(() => {
          if (this.$refs.matrixLMR && typeof this.$refs.matrixLMR.loadData === "function") {
            this.$refs.matrixLMR.loadData();
          }
        });
      }
    },
    "filter.AsuID"(val) {
      if (val === 0) this.filter.AsuID = null;
    },
    "filter.TypeSubstances"(val) {
      if (val === 0) this.filter.TypeSubstances = null;
    },
    "filter.CmaID"(val) {
      if (val === 0) this.filter.CmaID = null;
    },
    "filter.TypeMarket"(val) {
      if (val === 0) this.filter.TypeMarket = null;
    },
  },
  methods: {
    refresh(item) {
      this.$emit("refresh", item);
    },
    rowSelected(items) {
      this.selected = items;
      this.$emit("rowSelected", items);
    },
    clearForm() {
      this.$nextTick(() => {
        if (this.$refs.MRLValue && this.$refs.MRLValue.focus) {
          this.$refs.MRLValue.focus();
        }
      });
    },
    save(item) {
      if (!item.CmaID) {
        this.$fun.alert("Por favor seleccione la campaña", "warning");
        return;
      }
      if (!item.AsuID) {
        this.$fun.alert("Por favor seleccione la sustancia", "warning");
        return;
      }
      if (!item.TypeMarket) {
        this.$fun.alert("Por favor seleccione el mercado", "warning");
        return;
      }
      if (item.MRLValue === null || item.MRLValue === undefined || item.MRLValue === "") {
        this.$fun.alert("Por favor ingrese el valor LMR", "warning");
        return;
      }

      item.UsrCreateID = this.$fun.getUserID();
      item.UsrUpdateID = this.$fun.getUserID();
      item.save();
    },
  },
};
</script>

<style scoped>
.custom-tabs ::v-deep .v-tab {
  text-transform: none;
  font-size: 0.95rem;
  letter-spacing: 0.2px;
}
</style>
